import { AUTHORITIES } from '@/shared/auth/authorities';
import { pageAuthorities } from '@/shared/auth/has-any-authority';
/**
 * Permission action strings referenced by routes, menus, and in-page feature gates.
 * Canonical IAM catalogue (IDs/descriptions): `call-center-permissions.ts`.
 * Runtime keys are generated in `authorities.ts` from that catalogue.
 */
export const APP_PERMISSIONS = {
    // Shared Permissions (Both Systems)
    ADMIN: AUTHORITIES.ADMIN,
    CUSTOMER_READ: AUTHORITIES.CUSTOMER_READ,
    USER_CREATE: AUTHORITIES.USER_CREATE,
    USER_READ: AUTHORITIES.USER_READ,
    USER_UPDATE: AUTHORITIES.USER_UPDATE,
    USER_DELETE: AUTHORITIES.USER_DELETE,
    ROLE_READ: AUTHORITIES.ROLE_READ,
    ROLE_CREATE: AUTHORITIES.ROLE_CREATE,
    ROLE_UPDATE: AUTHORITIES.ROLE_UPDATE,
    ROLE_DELETE: AUTHORITIES.ROLE_DELETE,
    PERMISSION_READ: AUTHORITIES.PERMISSION_READ,
    // Case Management Pages
    CASEMANAGEMENT_DASHBOARD: AUTHORITIES.CASEMANAGEMENT_DASHBOARD,
    CASEMANAGEMENT_AGENTPANEL: AUTHORITIES.CASEMANAGEMENT_AGENTPANEL,
    CASEMANAGEMENT_CASESPANEL: AUTHORITIES.CASEMANAGEMENT_CASESPANEL,
    CASEMANAGEMENT_CASEREPORT: AUTHORITIES.CASEMANAGEMENT_CASEREPORT,
    CASEMANAGEMENT_CASEASSIGNMENT: AUTHORITIES.CASEMANAGEMENT_CASEASSIGNMENT,
    CASEMANAGEMENT_CASETRANSFER: AUTHORITIES.CASEMANAGEMENT_CASETRANSFER,
    CASEMANAGEMENT_FOLLOWUPCASES: AUTHORITIES.CASEMANAGEMENT_FOLLOWUPCASES,
    CASEMANAGEMENT_CASECATEGORIES: AUTHORITIES.CASEMANAGEMENT_CASECATEGORIES,
    CASE_CATEGORY_CREATE: AUTHORITIES.CASE_CATEGORY_CREATE,
    CASE_CATEGORY_READ: AUTHORITIES.CASE_CATEGORY_READ,
    CASE_CATEGORY_UPDATE: AUTHORITIES.CASE_CATEGORY_UPDATE,
    CASE_CATEGORY_DELETE: AUTHORITIES.CASE_CATEGORY_DELETE,
    CASEMANAGEMENT_PROVINCE: AUTHORITIES.CASEMANAGEMENT_PROVINCE,
    CASEMANAGEMENT_BRANCHES: AUTHORITIES.CASEMANAGEMENT_BRANCHES,
    // Case Management
    CASE_SUPERVISOR: AUTHORITIES.CASE_SUPERVISOR,
    CASE_CREATE: AUTHORITIES.CASE_CREATE,
    CASE_READ: AUTHORITIES.CASE_READ,
    CASE_UPDATE: AUTHORITIES.CASE_UPDATE,
    CASE_ASSIGNMENT_CREATE: AUTHORITIES.CASEASSIGNMENT_CREATE,
    CASE_ASSIGNMENT_DELETE: AUTHORITIES.CASEASSIGNMENT_DELETE,
    CASE_TRANSFER_CREATE: AUTHORITIES.CASETRANSFER_CREATE,
    CASES_READ: AUTHORITIES.CASES_READ,
    CASE_REPORT_READ: AUTHORITIES.CASEREPORT_READ,
    CASE_REPORT_ADMIN: AUTHORITIES.CASEREPORT_ADMIN,
    // Financial
    FINANCIAL_AIRPLANETICKET: AUTHORITIES.FINANCIAL_AIRPLANETICKET,
    AIRPLANE_TICKET_CREATE: AUTHORITIES.AIRPLANETICKET_CREATE,
    AIRPLANE_TICKET_READ: AUTHORITIES.AIRPLANETICKET_READ,
    // Ticket
    TICKET_READ: AUTHORITIES.TICKET_READ,
    // Branch
    BRANCH_CREATE: AUTHORITIES.BRANCH_CREATE,
    BRANCH_UPDATE: AUTHORITIES.BRANCH_UPDATE,
    BRANCH_DELETE: AUTHORITIES.BRANCH_DELETE,
    BRANCH_READ: AUTHORITIES.BRANCH_READ,
    // Department
    DEPARTMENT_CREATE: AUTHORITIES.DEPARTMENT_CREATE,
    DEPARTMENT_READ: AUTHORITIES.DEPARTMENT_READ,
    DEPARTMENT_UPDATE: AUTHORITIES.DEPARTMENT_UPDATE,
    DEPARTMENT_DELETE: AUTHORITIES.DEPARTMENT_DELETE,
    // Province
    PROVINCE_CREATE: AUTHORITIES.PROVINCE_CREATE,
    PROVINCE_READ: AUTHORITIES.PROVINCE_READ,
    PROVINCE_UPDATE: AUTHORITIES.PROVINCE_UPDATE,
    PROVINCE_DELETE: AUTHORITIES.PROVINCE_DELETE,
    // Call Center — pages
    CALL_CENTER_DASHBOARD: AUTHORITIES.CALL_CENTER_DASHBOARD,
    CALL_CENTER_KPIDASHBOARD: AUTHORITIES.CALL_CENTER_KPIDASHBOARD,
    CALL_CENTER_READ: AUTHORITIES.CALL_CENTER_READ,
    CALL_CENTER_VOICEMAIL: AUTHORITIES.CALL_CENTER_VOICEMAIL,
    CALL_CENTER_INCOMINGCALLS: AUTHORITIES.CALL_CENTER_INCOMINGCALLS,
    CALL_CENTER_OUTGOINGCALLS: AUTHORITIES.CALL_CENTER_OUTGOINGCALLS,
    CALL_CENTER_QUEUE_STATUS: AUTHORITIES.CALL_CENTER_QUEUE_STATUS,
    CALL_CENTER_REALTIME: AUTHORITIES.CALL_CENTER_REALTIME,
    CALL_CENTER_AGENTMONITORING: AUTHORITIES.CALL_CENTER_AGENTMONITORING,
    // Call Center — entity / report actions
    VOICEMAIL_READ: AUTHORITIES.VOICEMAIL_READ,
    VOICEMAIL_DELETE: AUTHORITIES.VOICEMAIL_DELETE,
    INCOMING_READ: AUTHORITIES.INCOMING_READ,
    INCOMINGCALLS_ADMIN: AUTHORITIES.INCOMINGCALLS_ADMIN,
    OUTGOING_READ: AUTHORITIES.OUTGOING_READ,
    OUTGOINGCALLS_ADMIN: AUTHORITIES.OUTGOINGCALLS_ADMIN,
    QUEUELOG_READ: AUTHORITIES.QUEUELOG_READ,
    REALTIME_ACTIVECALLS: AUTHORITIES.REALTIME_ACTIVECALLS,
    REALTIME_QUEUEINFORMATION: AUTHORITIES.REALTIME_QUEUEINFORMATION,
    // QStat dashboard widgets
    DASHBOARD_KPI: AUTHORITIES.DASHBOARD_KPI,
    DASHBOARD_CALLQUEUES: AUTHORITIES.DASHBOARD_CALLQUEUES,
    DASHBOARD_INCOMINGCALLS: AUTHORITIES.DASHBOARD_INCOMINGCALLS,
    DASHBOARD_OUTGOINGCALLS: AUTHORITIES.DASHBOARD_OUTGOINGCALLS,
    DASHBOARD_AGENTS: AUTHORITIES.DASHBOARD_AGENTS,
    // Campaign
    CAMPAIGNS_DASHBOARD: AUTHORITIES.CAMPAIGNS_DASHBOARD,
    CAMPAIGNS_LIST: AUTHORITIES.CAMPAIGNS_LIST,
    CAMPAIGN_CREATE: AUTHORITIES.CAMPAIGN_CREATE,
    CAMPAIGN_READ: AUTHORITIES.CAMPAIGN_READ,
    CAMPAIGN_EDIT: AUTHORITIES.CAMPAIGN_EDIT,
    CAMPAIGN_DELETE: AUTHORITIES.CAMPAIGN_DELETE,
    CAMPAIGN_MANAGELEADS: AUTHORITIES.CAMPAIGN_MANAGELEADS,
    // Agent & Productivity
    AGENTPRODUCTIVITYREPORT_ADMIN: AUTHORITIES.AGENTPRODUCTIVITYREPORT_ADMIN,
    SESSIONREPORT_ADMIN: AUTHORITIES.SESSIONREPORT_ADMIN,
    // Chat
    CHATROOM_CREATE: AUTHORITIES.CHATROOM_CREATE,
    CHATROOM_READ: AUTHORITIES.CHATROOM_READ,
    CHATROOM_UPDATE: AUTHORITIES.CHATROOM_UPDATE,
    CHATROOM_DELETE: AUTHORITIES.CHATROOM_DELETE,
    CHATMESSAGE_CREATE: AUTHORITIES.CHATMESSAGE_CREATE,
    CHATMESSAGE_READ: AUTHORITIES.CHATMESSAGE_READ,
    CHATMESSAGE_UPDATE: AUTHORITIES.CHATMESSAGE_UPDATE,
    CHATMESSAGE_DELETE: AUTHORITIES.CHATMESSAGE_DELETE,
    // Settings
    SETTINGS_USERS: AUTHORITIES.SETTINGS_USERS,
    SETTINGS_AGENTPRODUCTIVITYREPORT: AUTHORITIES.SETTINGS_AGENTPRODUCTIVITYREPORT,
    SETTINGS_SESSIONREPORT: AUTHORITIES.SETTINGS_SESSIONREPORT,
    SETTINGS_ROLES: AUTHORITIES.SETTINGS_ROLES,
    SETTINGS_PERMISSIONS: AUTHORITIES.SETTINGS_PERMISSIONS,
    SETTINGS_DEPARTMENTS: AUTHORITIES.SETTINGS_DEPARTMENTS,
    SETTINGS_AUDITLOG: AUTHORITIES.SETTINGS_AUDITLOG,
    AUDIT_READ: AUTHORITIES.AUDIT_LOG_READ,
    CALL_SUPERVISING: AUTHORITIES.CALL_SUPERVISING,
    // District
    DISTRICT_CREATE: AUTHORITIES.DISTRICT_CREATE,
    DISTRICT_DELETE: AUTHORITIES.DISTRICT_DELETE,
    DISTRICT_READ: AUTHORITIES.DISTRICT_READ,
    DISTRICT_UPDATE: AUTHORITIES.DISTRICT_UPDATE,
    // Pause Call
    PAUSE_CALL: AUTHORITIES.PAUSE_CALL,
    // Agent Statistics
    AGENT_STATICS: AUTHORITIES.AGENT_STATICS,
    // Wallboard Read
    WALLBOARD_READ: AUTHORITIES.WALLBOARD_READ,
    // Break Report Read
    BREAK_REPORT_READ: AUTHORITIES.BREAK_REPORT_READ,
};
/** Pre-built authority lists for `AuthRoute`, menu items, and `useHasAnyAuthority`. */
export const APP_FEATURE_GUARDS = {
    branchCreate: pageAuthorities(APP_PERMISSIONS.BRANCH_CREATE),
    branchUpdate: pageAuthorities(APP_PERMISSIONS.BRANCH_UPDATE),
    branchDelete: pageAuthorities(APP_PERMISSIONS.BRANCH_DELETE),
    agentPanelCustomerDetails: pageAuthorities(APP_PERMISSIONS.CUSTOMER_READ),
    caseTransferSupervisor: pageAuthorities(APP_PERMISSIONS.CASE_SUPERVISOR),
    caseCreate: pageAuthorities(APP_PERMISSIONS.CASE_CREATE),
    roleCreate: pageAuthorities(APP_PERMISSIONS.ROLE_CREATE),
    roleUpdate: pageAuthorities(APP_PERMISSIONS.ROLE_UPDATE),
    roleDelete: pageAuthorities(APP_PERMISSIONS.ROLE_DELETE),
    chatAccess: pageAuthorities(APP_PERMISSIONS.CHATROOM_READ, APP_PERMISSIONS.CHATMESSAGE_READ),
    chatRoomCreate: pageAuthorities(APP_PERMISSIONS.CHATROOM_CREATE),
    chatRoomUpdate: pageAuthorities(APP_PERMISSIONS.CHATROOM_UPDATE),
    chatRoomDelete: pageAuthorities(APP_PERMISSIONS.CHATROOM_DELETE),
    chatMessageCreate: pageAuthorities(APP_PERMISSIONS.CHATMESSAGE_CREATE),
    callSupervising: pageAuthorities(APP_PERMISSIONS.CALL_SUPERVISING),
    chatMessageUpdate: pageAuthorities(APP_PERMISSIONS.CHATMESSAGE_UPDATE),
    chatMessageDelete: pageAuthorities(APP_PERMISSIONS.CHATMESSAGE_DELETE),
    userCreate: pageAuthorities(APP_PERMISSIONS.USER_CREATE),
    userRead: pageAuthorities(APP_PERMISSIONS.USER_READ),
    userUpdate: pageAuthorities(APP_PERMISSIONS.USER_UPDATE),
    userDelete: pageAuthorities(APP_PERMISSIONS.USER_DELETE),
    departmentCreate: pageAuthorities(APP_PERMISSIONS.DEPARTMENT_CREATE),
    departmentRead: pageAuthorities(APP_PERMISSIONS.DEPARTMENT_READ),
    departmentUpdate: pageAuthorities(APP_PERMISSIONS.DEPARTMENT_UPDATE),
    departmentDelete: pageAuthorities(APP_PERMISSIONS.DEPARTMENT_DELETE),
    provinceCreate: pageAuthorities(APP_PERMISSIONS.PROVINCE_CREATE),
    provinceRead: pageAuthorities(APP_PERMISSIONS.PROVINCE_READ),
    provinceUpdate: pageAuthorities(APP_PERMISSIONS.PROVINCE_UPDATE),
    provinceDelete: pageAuthorities(APP_PERMISSIONS.PROVINCE_DELETE),
    campaignCreate: pageAuthorities(APP_PERMISSIONS.CAMPAIGN_CREATE),
    campaignRead: pageAuthorities(APP_PERMISSIONS.CAMPAIGN_READ),
    campaignEdit: pageAuthorities(APP_PERMISSIONS.CAMPAIGN_EDIT),
    campaignDelete: pageAuthorities(APP_PERMISSIONS.CAMPAIGN_DELETE),
    campaignManageLeads: pageAuthorities(APP_PERMISSIONS.CAMPAIGN_MANAGELEADS),
    caseCategoryCreate: pageAuthorities(APP_PERMISSIONS.CASE_CATEGORY_CREATE),
    caseCategoryRead: pageAuthorities(APP_PERMISSIONS.CASE_CATEGORY_READ),
    caseCategoryUpdate: pageAuthorities(APP_PERMISSIONS.CASE_CATEGORY_UPDATE),
    caseCategoryDelete: pageAuthorities(APP_PERMISSIONS.CASE_CATEGORY_DELETE),
    airplaneTicketCreate: pageAuthorities(APP_PERMISSIONS.AIRPLANE_TICKET_CREATE),
    airplaneTicketRead: pageAuthorities(APP_PERMISSIONS.AIRPLANE_TICKET_READ),
    followUpCaseRead: pageAuthorities(APP_PERMISSIONS.CASE_READ),
    followUpCaseUpdate: pageAuthorities(APP_PERMISSIONS.CASE_UPDATE),
    caseAssignmentCreate: pageAuthorities(APP_PERMISSIONS.CASE_ASSIGNMENT_CREATE),
    caseAssignmentDelete: pageAuthorities(APP_PERMISSIONS.CASE_ASSIGNMENT_DELETE),
    caseTransferCreate: pageAuthorities(APP_PERMISSIONS.CASE_TRANSFER_CREATE),
    casesPanelRead: pageAuthorities(APP_PERMISSIONS.CASES_READ),
    caseReportRead: pageAuthorities(APP_PERMISSIONS.CASE_REPORT_READ, APP_PERMISSIONS.CASE_REPORT_ADMIN),
    caseReportAdmin: pageAuthorities(APP_PERMISSIONS.CASE_REPORT_ADMIN),
    caseRead: pageAuthorities(APP_PERMISSIONS.CASE_READ),
    districtCreate: pageAuthorities(APP_PERMISSIONS.DISTRICT_CREATE),
    districtDelete: pageAuthorities(APP_PERMISSIONS.DISTRICT_DELETE),
    districtRead: pageAuthorities(APP_PERMISSIONS.DISTRICT_READ),
    districtUpdate: pageAuthorities(APP_PERMISSIONS.DISTRICT_UPDATE),
    pauseCall: pageAuthorities(APP_PERMISSIONS.PAUSE_CALL),
    agentStatistics: pageAuthorities(APP_PERMISSIONS.AGENT_STATICS),
    wallboardRead: pageAuthorities(APP_PERMISSIONS.WALLBOARD_READ),
    caseUpdate: pageAuthorities(APP_PERMISSIONS.CASE_UPDATE),
    qstatDashboardRead: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_DASHBOARD, APP_PERMISSIONS.CALL_CENTER_READ),
    kpiDashboardRead: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_KPIDASHBOARD, APP_PERMISSIONS.DASHBOARD_KPI),
    qstatDashboardIncomingCalls: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_DASHBOARD, APP_PERMISSIONS.DASHBOARD_INCOMINGCALLS),
    qstatDashboardOutgoingCalls: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_DASHBOARD, APP_PERMISSIONS.DASHBOARD_OUTGOINGCALLS),
    qstatDashboardAgents: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_DASHBOARD, APP_PERMISSIONS.DASHBOARD_AGENTS),
    qstatDashboardCallQueues: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_DASHBOARD, APP_PERMISSIONS.DASHBOARD_CALLQUEUES),
    voicemailRead: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_VOICEMAIL, APP_PERMISSIONS.VOICEMAIL_READ),
    voicemailDelete: pageAuthorities(APP_PERMISSIONS.VOICEMAIL_DELETE),
    incomingCallsRead: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_INCOMINGCALLS, APP_PERMISSIONS.INCOMING_READ, APP_PERMISSIONS.INCOMINGCALLS_ADMIN),
    outgoingCallsRead: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_OUTGOINGCALLS, APP_PERMISSIONS.OUTGOING_READ, APP_PERMISSIONS.OUTGOINGCALLS_ADMIN),
    queueStatusRead: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_QUEUE_STATUS, APP_PERMISSIONS.QUEUELOG_READ),
    realtimeAccess: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_REALTIME, APP_PERMISSIONS.REALTIME_ACTIVECALLS, APP_PERMISSIONS.REALTIME_QUEUEINFORMATION),
    realtimeQueueInformation: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_REALTIME, APP_PERMISSIONS.REALTIME_QUEUEINFORMATION),
    realtimeActiveCalls: pageAuthorities(APP_PERMISSIONS.CALL_CENTER_REALTIME, APP_PERMISSIONS.REALTIME_ACTIVECALLS),
    realtimeSupervisorActions: pageAuthorities(APP_PERMISSIONS.CALL_SUPERVISING),
    auditLogRead: pageAuthorities(APP_PERMISSIONS.AUDIT_READ),
    breakReportRead: pageAuthorities(APP_PERMISSIONS.BREAK_REPORT_READ),
};
